import React from 'react';
import './JxTooltipRowItemDescription.css';

/**
 * JxTooltipRows — wrapper voor meerdere JxTooltipRowItemDescription-rijen.
 * display:table op de wrapper + display:table-row/table-cell op de rijen
 * (zie JxTooltipRowItemDescription.css) laat de browser de kolombreedte van
 * de label-kolom automatisch uitrekenen op de BREEDSTE label in de hele set
 * — geen handmatige/vaste pixel-breedte nodig, en werkt vanzelf goed bij een
 * wisselend aantal/lengte rijen.
 *
 * Gebruik:
 * <JxTooltipRows>
 *   <JxTooltipRowItemDescription label="Double click" value="New waypoint" />
 *   <JxTooltipRowItemDescription label="Press D" value="Delete connector" />
 * </JxTooltipRows>
 */
function JxTooltipRows({ children }) {
  return <div className="jx-tooltip-rows">{children}</div>;
}

export default JxTooltipRows;
